import "styled-components";
import type { GlobalToken } from "antd";
import type { ThemeConfig } from "antd/lib/config-provider/context";

type ThemeExtension = {
  colorAccent: string;
  colorSecondary: string;
  spacing: number;
};

export const theme: ThemeConfig = {
  token: {
    colorPrimary: "#6C5CE7",
    borderRadius: 8,
  },
};

export const themeExtension: ThemeExtension = {
  colorAccent: "#219150",
  colorSecondary: "#F5F7FA",
  spacing: 8,
};

export type AppTheme = GlobalToken & ThemeExtension;

declare module "styled-components" {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface DefaultTheme extends AppTheme {}
}
